import React from 'react';

import './MessageList.scss';


class MessageList extends React.Component {
  render() {
    const {
      heading = '',
      messages = []
    } = this.props;

    return (
      <React.Fragment>
        <p className="parkchirp--message-list--heading">
          {heading}
        </p>
        <ul className="parkchirp--message-list--messages">
          {(messages.map((message, index) =>
            <li key={index}>{message}</li>
          ))}
        </ul>
      </React.Fragment>
    );
  }
}
export default MessageList;
